import { v4 as uuidv4 } from "uuid";
import { useGlobalStore } from "../globalStore";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchPostCancelInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const callFaceSwap = async (
	base64RefList: string[],
	messageId: string,
	userId: number,
) => {
	const { success } = await getTargetEditorImage({
		commandName: "Face Blend",
		includeMask: true,
		applyMaskToResultLayer: true,
		useLayerBoundsAsSource: true,
		maxSide: undefined,
		resultLayerName: "Face Blend",
		processImage: async ({ executionContext, imageBase64, maskBase64 }) => {
			const data = {
				base64_ref_list: base64RefList,
				base64_pose: imageBase64,
				base64_mask: maskBase64 ?? "",
				user_id: userId,
				plugin_version: useGlobalStore.getState().version,
			};

			return fetchFaceSwap(data, executionContext, messageId);
		},
	});

	return success;
};

export async function fetchFaceSwap(
	params: {
		base64_ref_list: string[];
		base64_pose: string;
		base64_mask: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchPostCancelInferenceJob(
		params,
		executionContext,
		messageId,
		"/face-blend",
	);
}

export function useListenFaceSwapMessage() {
	useListenFromRenderer([
		{
			key: "faceSwap",
			onMessage: async (message) => {
				const success = await callFaceSwap(
					message.values.base64RefList,
					message.id,
					message.values.userId,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
